<template>
  <div v-if="componentData" style="margin-top: 10px;">
    <select @change="onChange" v-model="componentData.componentId" style="width: 70%; height: 24px;">
      <option value=""></option>
      <option v-for="component in foodComponents" :key="component.idComp" :value="component.idComp">
        {{ component.description }}, {{ component.unitM }}
      </option>
    </select>
    <input style="margin-right: 3px;margin-left: 6px; width: 10%; height: 18px;" v-model="componentData.minValue" @input="onChange" type="number" min="0" />
    <input style="margin-right: 3px;margin-left: 3px; width: 10%; height: 18px;" v-model="componentData.maxValue" @input="onChange" type="number" min="0" />
  </div>
</template>

<script>
export default {
  name: "ComponentList",
  props: ["lang", "itemData", "index", "foodComponents"],
  emits: { changedValue: null },
  data() {
    return {
      language: 0,
      componentData: {
        componentId: this.itemData.componentId,
        minValue: this.itemData.minValue,
        maxValue: this.itemData.maxValue,
      }
    };
  },
  async mounted() {
    this.componentData.componentId = this.itemData.componentId;
    this.componentData.minValue = this.itemData.minValue;
    this.componentData.maxValue = this.itemData.maxValue;
  },
  watch: {
    itemData: {
      handler(val) {
        this.componentData.componentId = val.componentId;
        this.componentData.minValue = val.minValue;
        this.componentData.maxValue = val.maxValue;
      },
      deep: true
    }
  },
  methods: {
    onChange() {
      this.$emit("changedValue", this.componentData, parseInt(this.index));
    }    
  },
};
</script>

<style></style>